import BaseGrid from '@material-ui/core/Grid'

const Grid = BaseGrid

export default Grid
